import AndOpenLogo from '../components/AndOpenLogo.js'

export default function Home({ color }){
  return (
    <div className="home">
      <AndOpenLogo color={color} style={{ maxWidth: '200px' }} />
    </div>
  );
}
